// cSpell:ignore Silae
//
// Balises pour RichFormattedText : <b>, <i>, <m>

export function bold(value: string): string {
  if (!value) return value;
  return `<b>${value}</b>`;
}

export function italic(label: string): string {
  if (!label) return label;
  return `<i>${label}</i>`;
}

export function muted(text: string): string {
  if (!text) return text;
  return `<m>${text}</m>`;
}
